import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Text, Center,
} from '@mantine/core';

import { NARROW_COLUMN_STYLES } from './constants';

export default function useColNumberSchema() {
    const colDeleteSchema = {
        accessor: 'number',
        style: NARROW_COLUMN_STYLES,
        title: (
            <Center>
                <FontAwesomeIcon icon="hashtag" />
            </Center>
        ),
        render: ({ index }) => (
            <Center>
                <Text>{index + 1}</Text>
            </Center>
        ),
    };

    return colDeleteSchema;
}
